import {useMemo} from "react";
import {InfoContentType} from "@domain/rs/info/InfoCardListRs";

interface IInfoDetailArticleVideoProps {
    type: InfoContentType | null;
    videoUrl: string | null;
}

const InfoDetailArticleVideo: React.FC<IInfoDetailArticleVideoProps> = (props) => {
    const { type, videoUrl } = props;
    const url = useMemo(() => {
        return `https://www.youtube.com/embed/${videoUrl}`
    }, [videoUrl])

    if (!type || type === InfoContentType.TEXT) {
        return null;
    }

    return (
        <div className='frame-video'>
            <iframe
                title='youtube'
                width='100%'
                height='415px'
                src={url}
                frameBorder='0'
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                allowFullScreen
            />
        </div>
    );
};

export default InfoDetailArticleVideo;
